<!-- File Upload -->
<div fxLayout="column">
  <!-- View Sample -->
  <div class="label" [ngClass]="customStyle">
    {{ label | translate
    }}<span *ngIf="hasViewSample" (click)="onClickViewSample()">{{
      'file_upload.view_sample' | translate
    }}</span>
  </div>

  <form
    [ngClass]="customStyle"
    fxLayout="row wrap"
    fxLayoutAlign="start start"
    [formGroup]="uploadForm"
  >
    <!-- Hidden File Upload Input -->
    <input
      type="file"
      #fileUpload
      [accept]="allowedFileTypeList.join(',')"
      formControlName="fileInput"
      (change)="onChangeFile($event)"
    />

    <!-- File Upload Input -->
    <div fxLayout="column" [ngClass]="'col1-' + customStyle">
      <div class="p-inputgroup" [ngClass]="customStyle">
        <!-- File Name -->
        <input
          formControlName="file"
          type="text"
          pInputText
          placeholder="Browse your files"
          [readonly]="true"
          [value]="displayFileName"
          (click)="!disabled && fileUpload.click()"
          [class.disabled]="disabled"
        />

        <!-- Select Button -->
        <button
          type="button"
          pButton
          pRipple
          icon="pi pi-plus"
          [ngClass]="customStyle"
          (click)="!disabled && fileUpload.click()"
          [disabled]="disabled"
          *ngIf="!selectedFile"
        ></button>

        <!-- Clear Button -->
        <button
          type="button"
          pButton
          pRipple
          icon="pi pi-times"
          [ngClass]="customStyle"
          (click)="!disabled && onClickClear()"
          [disabled]="disabled"
          *ngIf="selectedFile"
        ></button>
      </div>
    </div>

    <!-- Upload Button -->
    <button
      *ngIf="showUploadButton"
      mat-flat-button
      color="primary"
      [disabled]="uploadForm.invalid"
      (click)="onClickUpload()"
    >
      {{ 'file_upload.upload' | translate }}
    </button>
  </form>

  <!-- Uploaded file name/link below the input -->
  <div
    *ngIf="uploadedFileUrl && !selectedFile"
    class="uploaded-file-preview"
    fxLayout="row"
    fxLayoutAlign="start center"
  >
    <a [href]="uploadedFileUrl" target="_blank">
      {{ viewFileLabel || ('file_upload.view_file' | translate) }}
    </a>
  </div>

  <!-- validation msg -->
  <app-validation-error
    [control]="uploadForm.get(['file'])"
    [field]="'file_upload.file' | translate"
  ></app-validation-error>

  <!-- Upload Report Links -->
  <div
    fxLayout="row"
    fxLayout.xs="column"
    fxLayoutAlign="start center"
    fxLayoutGap="10px"
    *ngIf="isFileUploaded"
  >
    <!-- Download Uploaded File -->
    <a [href]="uploadFilePath" *ngIf="uploadFilePath">
      {{ 'file_upload.download_uploaded_file' | translate }}
    </a>

    <!-- Download Error File -->
    <a [href]="errorFilePath" *ngIf="errorFilePath">
      {{ 'file_upload.download_error_report' | translate }}
    </a>
  </div>
</div>
